// extracted by mini-css-extract-plugin
export default {"wrap":"StrategyTemplate_wrap__4vlZn"};